import { normalizeFontId } from './font-registry.js';

export const DEFAULT_SETTINGS = Object.freeze({
  outputQuality: 'hd',
  exportScope: 'auto',
  reelType: 'standard',
  duration: 5,
  transitionDuration: 0.4,
  transitionMode: 'crossfade',
  motion: 'zoom_in_out',
  zoom: 1.04,
  motionSmoothness: 80,
  videoFitMode: 'fill',
  videoScale: 1,
  videoPositionX: 50,
  videoPositionY: 50,
  videoPlaybackRate: 1,
  videoEndBehavior: 'loop',
  heroPreset: 'power_stack',
  fontPair: 'instrument_google',
  heroFont: 'InstrumentSerif-Regular.ttf',
  bodyFont: 'GoogleSans-Medium.ttf',
  heroSize: 86,
  heroSupportSize: 62,
  heroPowerSize: 108,
  bodySize: 42,
  titleY: 25,
  bodyY: 45,
  heroAlign: 'center',
  bodyAlign: 'center',
  textColor: '#ffffff',
  accentColor: '#c7ff36',
  titleMaterial: 'solid',
  goldApply: 'all',
  goldTone: 'classic',
  goldDepth: 3.5,
  goldHighlight: 88,
  goldContrast: 64,
  goldTexture: 12,
  goldStroke: 1.5,
  heroShadow: true,
  heroShadowColor: '#000000',
  heroShadowOpacity: 72,
  heroShadowBlur: 12,
  heroShadowX: 0,
  heroShadowY: 3,
  coverBackgroundMode: 'fit',
  coverBackgroundColor: '#11151d',
  coverBackgroundOpacity: 88,
  coverBackgroundRadius: 18,
  coverBackgroundPaddingX: 28,
  coverBackgroundPaddingY: 18,
  coverBorderEnabled: false,
  coverBorderColor: '#ffffff',
  coverBorderOpacity: 35,
  coverBorderWidth: 1,
  bodyTextColor: '#ffffff',
  cardColor: '#11151d',
  cardOpacity: 88,
  bodyCardMode: 'fit',
  bodyCardRadius: 18,
  bodyCardPaddingX: 28,
  bodyCardPaddingY: 18,
  bodyBorderEnabled: false,
  bodyBorderColor: '#ffffff',
  bodyBorderOpacity: 35,
  bodyBorderWidth: 1,
  bodyShadow: true,
  bodyShadowColor: '#000000',
  bodyShadowOpacity: 55,
  bodyShadowBlur: 5,
  bodyShadowX: 0,
  bodyShadowY: 2,
  overlayOpacity: 18,
  overlayEnabled: true,
  coverTextAnimation: 'fade',
  bodyTextAnimation: 'fade',
  coverTextAnimationDuration: 0.7,
  bodyTextAnimationDuration: 0.7,
  subtextEnabled: true,
  subtext: 'Read in Caption',
  subtextFont: 'GoogleSans-Medium.ttf',
  subtextAlign: 'center',
  subtextDelay: 2,
  subtextSize: 30,
  subtextY: 68,
  subtextGap: 24,
  subtextColor: '#ffffff',
  subtextAnimation: 'fade',
  subtextOutAnimation: 'fade',
  subtextAnimationDuration: 0.4,
  subtextExitBeforeEnd: 0.15,
  subtextShadow: true,
  subtextShadowOpacity: 65,
  subtextShadowBlur: 5,
  subtextShadowX: 3,
  subtextShadowY: 3,
  subtextBackground: false,
  subtextBackgroundColor: '#141414',
  watermark: '',
  watermarkSize: 28,
  watermarkOpacity: 72,
  socialIcon: 'none'
});

export function moveItem(items, from, to) {
  if (!Array.isArray(items) || !Number.isInteger(from) || !Number.isInteger(to) || from === to || from < 0 || to < 0 || from >= items.length || to >= items.length) return false;
  const [moved] = items.splice(from, 1);
  items.splice(to, 0, moved);
  return true;
}

export const OUTPUT_PRESETS = Object.freeze({
  hd: Object.freeze({ label: 'HD', detail: '1080 × 1920', width: 1080, height: 1920 }),
  '2k': Object.freeze({ label: '2K', detail: '1440 × 2560', width: 1440, height: 2560 }),
  '4k': Object.freeze({ label: '4K', detail: '2160 × 3840', width: 2160, height: 3840 })
});

export const PROFILE_TRANSFER_FORMAT = 'reelpro-client-profiles';
export const PROFILE_TRANSFER_VERSION = 1;
export const PROFILE_SETTINGS_SCHEMA_VERSION = 4;
const PORTABLE_TO_PWA = Object.freeze({
  reel_type:'reelType',font_pair:'fontPair',hero_font:'heroFont',body_font:'bodyFont',hero_size:'heroSize',hero_support_size:'heroSupportSize',hero_power_size:'heroPowerSize',
  body_size:'bodySize',body_position_y:'bodyY',body_align:'bodyAlign',body_text_color:'bodyTextColor',hero_position_y:'titleY',hero_align:'heroAlign',hero_preset:'heroPreset',hero_text_color:'textColor',hero_accent_color:'accentColor',
  hero_title_material:'titleMaterial',hero_gold_apply:'goldApply',hero_gold_tone:'goldTone',hero_gold_depth:'goldDepth',hero_gold_highlight:'goldHighlight',hero_gold_contrast:'goldContrast',hero_gold_texture:'goldTexture',hero_gold_stroke:'goldStroke',
  hero_shadow:'heroShadow',hero_shadow_color:'heroShadowColor',hero_shadow_opacity:'heroShadowOpacity',hero_shadow_blur:'heroShadowBlur',hero_shadow_offset_x:'heroShadowX',hero_shadow_offset_y:'heroShadowY',hero_overlay_enabled:'overlayEnabled',hero_overlay_opacity:'overlayOpacity',
  cover_subtext_enabled:'subtextEnabled',cover_subtext:'subtext',cover_subtext_size:'subtextSize',cover_subtext_position_y:'subtextY',cover_subtext_color:'subtextColor',cover_subtext_delay:'subtextDelay',cover_subtext_in_animation:'subtextAnimation',cover_subtext_animation_duration:'subtextAnimationDuration',cover_subtext_shadow:'subtextShadow',cover_subtext_shadow_opacity:'subtextShadowOpacity',cover_subtext_shadow_blur:'subtextShadowBlur',
  cover_background_mode:'coverBackgroundMode',cover_background_color:'coverBackgroundColor',cover_background_opacity:'coverBackgroundOpacity',cover_background_radius:'coverBackgroundRadius',cover_background_padding_x:'coverBackgroundPaddingX',cover_background_padding_y:'coverBackgroundPaddingY',cover_background_border_enabled:'coverBorderEnabled',cover_background_border_color:'coverBorderColor',cover_background_border_opacity:'coverBorderOpacity',cover_background_border_width:'coverBorderWidth',
  body_background_mode:'bodyCardMode',body_background_color:'cardColor',body_background_opacity:'cardOpacity',body_background_radius:'bodyCardRadius',body_background_padding_x:'bodyCardPaddingX',body_background_padding_y:'bodyCardPaddingY',body_background_border_enabled:'bodyBorderEnabled',body_background_border_color:'bodyBorderColor',body_background_border_opacity:'bodyBorderOpacity',body_background_border_width:'bodyBorderWidth',
  body_shadow:'bodyShadow',body_shadow_color:'bodyShadowColor',body_shadow_opacity:'bodyShadowOpacity',body_shadow_blur:'bodyShadowBlur',body_shadow_offset_x:'bodyShadowX',body_shadow_offset_y:'bodyShadowY',duration:'duration',zoom:'zoom',motion_mode:'motion',motion_smoothness:'motionSmoothness',transition_mode:'transitionMode',transition_duration:'transitionDuration',cover_text_animation:'coverTextAnimation',body_text_animation:'bodyTextAnimation',cover_text_animation_duration:'coverTextAnimationDuration',body_text_animation_duration:'bodyTextAnimationDuration',watermark:'watermark',watermark_size:'watermarkSize',watermark_opacity:'watermarkOpacity',social_icon:'socialIcon',output_quality:'outputQuality',export_scope:'exportScope',
  video_fit_mode:'videoFitMode',video_scale:'videoScale',video_position_x:'videoPositionX',video_position_y:'videoPositionY',video_playback_rate:'videoPlaybackRate',video_end_behavior:'videoEndBehavior',
  cover_subtext_font:'subtextFont',cover_subtext_align:'subtextAlign',cover_subtext_gap:'subtextGap',cover_subtext_out_animation:'subtextOutAnimation',cover_subtext_exit_before_end:'subtextExitBeforeEnd',cover_subtext_shadow_offset_x:'subtextShadowX',cover_subtext_shadow_offset_y:'subtextShadowY',cover_subtext_background:'subtextBackground',cover_subtext_background_color:'subtextBackgroundColor'
});
const PWA_TO_PORTABLE = Object.freeze(Object.fromEntries(Object.entries(PORTABLE_TO_PWA).map(([portable,pwa]) => [pwa,portable])));

const ENUM_SETTINGS = Object.freeze({
  outputQuality: ['hd', '2k', '4k'], exportScope: ['auto', 'main', 'all', 'trials'],
  heroPreset: ['classic', 'editorial', 'minimal', 'power_stack', 'dual_font', 'magazine', 'oversized_keyword', 'bottom_editorial', 'framed', 'split_headline', 'minimal_luxury', 'bold_condensed'],
  titleMaterial: ['solid', 'gold_embossed'], goldApply: ['all', 'power', 'all_power'], goldTone: ['classic', 'warm', 'antique', 'rose'],
  heroAlign: ['left', 'center', 'right'], bodyAlign: ['left', 'center', 'right'], subtextAlign: ['left', 'center', 'right'],
  coverBackgroundMode: ['none', 'fit', 'band'], bodyCardMode: ['none', 'fit', 'band'],
  motion: ['none', 'alternate', 'zoom_in', 'zoom_out', 'zoom_in_out'],
  videoFitMode: ['fill', 'fit', 'stretch'], videoEndBehavior: ['loop', 'freeze'],
  transitionMode: ['cut', 'crossfade', 'fade_black', 'slide_left', 'wipe_left'],
  coverTextAnimation: ['none', 'fade', 'pop', 'slide_up', 'typewriter'], bodyTextAnimation: ['none', 'fade', 'pop', 'slide_up', 'typewriter'],
  subtextAnimation: ['none', 'fade', 'slide_up'], subtextOutAnimation: ['none', 'fade', 'slide_down'],
  socialIcon: ['ig', 'yt', 'fb', 'tiktok', 'x', 'linkedin', 'none'],
});
const NUMBER_RANGES = Object.freeze({
  duration:[2,15], transitionDuration:[0,2], zoom:[1,1.15], motionSmoothness:[20,100],
  videoScale:[.25,2.5], videoPositionX:[0,100], videoPositionY:[0,100], videoPlaybackRate:[.25,3],
  heroSize:[24,180], heroSupportSize:[20,180], heroPowerSize:[20,200], bodySize:[20,100], titleY:[10,90], bodyY:[10,90], overlayOpacity:[0,70],
  goldDepth:[0,12], goldHighlight:[0,100], goldContrast:[0,100], goldTexture:[0,100], goldStroke:[0,8],
  coverBackgroundOpacity:[0,100], coverBackgroundRadius:[0,100], coverBackgroundPaddingX:[0,120], coverBackgroundPaddingY:[0,120], coverBorderOpacity:[0,100], coverBorderWidth:[0,20],
  heroShadowOpacity:[0,100], heroShadowBlur:[0,40], heroShadowX:[-30,30], heroShadowY:[-30,30],
  cardOpacity:[0,100], bodyCardRadius:[0,100], bodyCardPaddingX:[0,120], bodyCardPaddingY:[0,120], bodyBorderOpacity:[0,100], bodyBorderWidth:[0,20],
  bodyShadowOpacity:[0,100], bodyShadowBlur:[0,40], bodyShadowX:[-30,30], bodyShadowY:[-30,30], coverTextAnimationDuration:[.1,4], bodyTextAnimationDuration:[.1,4],
  subtextDelay:[0,12], subtextSize:[12,100], subtextY:[10,90], subtextGap:[0,160], subtextAnimationDuration:[.1,4], subtextExitBeforeEnd:[0,5],
  subtextShadowOpacity:[0,100], subtextShadowBlur:[0,40], subtextShadowX:[-30,30], subtextShadowY:[-30,30], watermarkSize:[12,96], watermarkOpacity:[0,100],
});
const HEX_COLOR = /^#[0-9a-f]{6}$/i;

function normalizedSetting(key, value) {
  const fallback = DEFAULT_SETTINGS[key];
  if (ENUM_SETTINGS[key]) return ENUM_SETTINGS[key].includes(value) ? value : fallback;
  if (NUMBER_RANGES[key]) {
    const number = Number(value);
    if (!Number.isFinite(number)) return fallback;
    const [min,max] = NUMBER_RANGES[key];
    return Math.min(max, Math.max(min, number));
  }
  if (typeof fallback === 'boolean') {
    if (typeof value === 'boolean') return value;
    if (value === 'true' || value === 1) return true;
    if (value === 'false' || value === 0) return false;
    return fallback;
  }
  if (typeof fallback === 'string') {
    if (typeof value !== 'string') return fallback;
    if (key.endsWith('Color')) return HEX_COLOR.test(value) ? value.toLowerCase() : fallback;
    return value.slice(0, key === 'subtext' ? 240 : key === 'watermark' ? 100 : 160);
  }
  return fallback;
}

export function importProfileSettings(settings) {
  if (!settings || typeof settings !== 'object' || Array.isArray(settings)) throw new Error('Each imported profile must contain a settings object.');
  const schemaVersion = Number(settings.profile_schema_version || settings.profileSchemaVersion || 1);
  if (!Number.isInteger(schemaVersion) || schemaVersion < 1) throw new Error('The profile settings version is invalid.');
  if (schemaVersion > PROFILE_SETTINGS_SCHEMA_VERSION) throw new Error('This profile was created by a newer ReelPro version. Update the app before loading it.');
  const converted = { ...settings };
  for (const [portable,pwa] of Object.entries(PORTABLE_TO_PWA)) {
    // Some portable keys intentionally have the same name in both apps.
    // Keep those values in place instead of deleting them as aliases.
    if (portable === pwa) continue;
    if (portable in settings && !(pwa in settings)) converted[pwa] = settings[portable];
    delete converted[portable];
  }
  // Pre-background-card desktop profiles used these legacy fields. Modern
  // fields win when both are present, but old profiles still import faithfully.
  if (!('cardColor' in converted) && 'body_card_color' in settings) converted.cardColor = settings.body_card_color;
  if (!('coverBackgroundMode' in converted) && !('bodyCardMode' in converted) && 'box_mode' in settings) {
    if (settings.box_mode === 'all_on') {
      converted.coverBackgroundMode = 'fit';
      converted.bodyCardMode = 'fit';
    } else if (settings.box_mode === 'all_off') {
      converted.coverBackgroundMode = 'none';
      converted.bodyCardMode = 'none';
    }
  }
  if ('textAnimationDuration' in converted) {
    if (!('coverTextAnimationDuration' in converted)) converted.coverTextAnimationDuration = converted.textAnimationDuration;
    if (!('bodyTextAnimationDuration' in converted)) converted.bodyTextAnimationDuration = converted.textAnimationDuration;
  }
  delete converted.profile_schema_version;
  delete converted.profileSchemaVersion;
  const imported = { ...DEFAULT_SETTINGS };
  for (const key of Object.keys(DEFAULT_SETTINGS)) if (key in converted) imported[key] = normalizedSetting(key, converted[key]);
  imported.heroFont = normalizeFontId(imported.heroFont, DEFAULT_SETTINGS.heroFont);
  imported.bodyFont = normalizeFontId(imported.bodyFont, DEFAULT_SETTINGS.bodyFont);
  imported.subtextFont = normalizeFontId(imported.subtextFont, DEFAULT_SETTINGS.subtextFont);
  return imported;
}

export function exportProfileSettings(settings) {
  const portable = { profile_schema_version: PROFILE_SETTINGS_SCHEMA_VERSION };
  for (const [key,value] of Object.entries(settings || {})) if (PWA_TO_PORTABLE[key]) portable[PWA_TO_PORTABLE[key]] = value;
  for (const [key,value] of Object.entries(settings || {})) if (!PWA_TO_PORTABLE[key] && !(key in PORTABLE_TO_PWA) && !(key in portable)) portable[key] = value;
  return portable;
}

function normalizePastedScriptText(value) {
  let text = String(value ?? '').replace(/\u00a0/g, ' ').trim();
  text = text.replace(/(?:&#x20;|&#32;|&nbsp;)\s*$/gi, '').trim();
  const fenced = text.match(/^```(?:json)?\s*([\s\S]*?)\s*```$/i);
  return (fenced ? fenced[1] : text).trim();
}

function repairStringArrayJSON(text) {
  if (!text.startsWith('[')) return text;
  let repaired = '';
  let inString = false;
  let escaped = false;
  for (let index = 0; index < text.length; index += 1) {
    const character = text[index];
    if (!inString) {
      repaired += character;
      if (character === '"') inString = true;
      continue;
    }
    if (escaped) {
      repaired += character;
      escaped = false;
      continue;
    }
    if (character === '\\') {
      repaired += character;
      escaped = true;
      continue;
    }
    if (character === '\n' || character === '\r') {
      if (character === '\r' && text[index + 1] === '\n') index += 1;
      repaired += '\\n';
      continue;
    }
    if (character === '"') {
      let nextIndex = index + 1;
      while (/\s/.test(text[nextIndex] || '')) nextIndex += 1;
      if (text[nextIndex] === ',' || text[nextIndex] === ']') {
        repaired += character;
        inString = false;
      } else {
        repaired += '\\"';
      }
      continue;
    }
    repaired += character;
  }
  return repaired;
}

export function parseScript(value) {
  const text = normalizePastedScriptText(value);
  if (!text) return [];
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch {
    try {
      parsed = JSON.parse(repairStringArrayJSON(text));
    } catch {
      if (!/^[\[{\"]/.test(text)) return [text];
      throw new Error('The pasted script could not be repaired. Use a title string or a JSON array with one quoted string per slide.');
    }
  }
  if (typeof parsed === 'string') parsed = [parsed];
  if (parsed && !Array.isArray(parsed) && Array.isArray(parsed.slides)) parsed = parsed.slides;
  if (!Array.isArray(parsed)) throw new Error('Use a JSON string or an array of strings.');
  const slides = parsed.map((item) => String(item ?? '').trim()).filter(Boolean);
  if (!slides.length) throw new Error('The script has no usable slide text.');
  return slides;
}

export function isVideoItem(item) {
  return item?.mediaType === 'video' || String(item?.type || '').startsWith('video/');
}

export function normalizeMediaItem(item, settings = DEFAULT_SETTINGS) {
  if (!item || typeof item !== 'object') return item;
  const video = isVideoItem(item);
  const number = (value, fallback, min, max) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? Math.min(max, Math.max(min, parsed)) : fallback;
  };
  return {
    ...item,
    mediaType: video ? 'video' : 'image',
    fitMode: ['fill', 'fit', 'stretch'].includes(item.fitMode) ? item.fitMode : video ? settings.videoFitMode : 'fill',
    scale: number(item.scale, video ? settings.videoScale : 1, .25, 2.5),
    positionX: number(item.positionX, video ? settings.videoPositionX : 50, 0, 100),
    positionY: number(item.positionY, video ? settings.videoPositionY : 50, 0, 100),
    trimStart: number(item.trimStart, 0, 0, 86400),
    trimEnd: number(item.trimEnd, 0, 0, 86400),
    playbackRate: number(item.playbackRate, video ? settings.videoPlaybackRate : 1, .25, 3),
    endBehavior: ['loop', 'freeze'].includes(item.endBehavior) ? item.endBehavior : video ? settings.videoEndBehavior : 'loop',
    duration: number(item.duration, 0, 0, 86400)
  };
}

export function resolveVideoTime(item, slideTime, mediaDuration = item?.duration) {
  const duration = Math.max(0, Number(mediaDuration) || 0);
  if (!duration) return 0;
  const start = Math.min(duration, Math.max(0, Number(item?.trimStart) || 0));
  const requestedEnd = Number(item?.trimEnd) || duration;
  const end = Math.min(duration, Math.max(start, requestedEnd));
  const span = Math.max(1 / 1000, end - start);
  const elapsed = Math.max(0, Number(slideTime) || 0) * Math.max(.25, Number(item?.playbackRate) || 1);
  if (item?.endBehavior === 'freeze') return Math.min(end - 1 / 1000, start + elapsed);
  return start + (elapsed % span);
}

export function mediaDrawRect(sourceWidth, sourceHeight, width, height, item = {}, extraScale = 1) {
  const sw = Math.max(1, Number(sourceWidth) || 1), sh = Math.max(1, Number(sourceHeight) || 1);
  const mode = ['fill', 'fit', 'stretch'].includes(item.fitMode) ? item.fitMode : 'fill';
  const scale = Math.max(.01, Number(item.scale) || 1) * Math.max(.01, Number(extraScale) || 1);
  let dw, dh;
  if (mode === 'stretch') { dw = width * scale; dh = height * scale; }
  else { const base = (mode === 'fit' ? Math.min : Math.max)(width / sw, height / sh); dw = sw * base * scale; dh = sh * base * scale; }
  const x = Math.min(100, Math.max(0, Number(item.positionX ?? 50))) / 100;
  const y = Math.min(100, Math.max(0, Number(item.positionY ?? 50))) / 100;
  return { x:(width - dw) * x, y:(height - dh) * y, width:dw, height:dh };
}

export function projectSlideCount(project) {
  const mediaCount = Array.isArray(project?.images) ? project.images.length : 0;
  const scriptCount = Array.isArray(project?.script) ? project.script.length : 0;
  return scriptCount ? Math.min(mediaCount, scriptCount) : mediaCount;
}

export function normalizeProject(project) {
  const rawImages = Array.isArray(project.images) ? project.images : [];
  const script = Array.isArray(project.script) ? project.script : [];
  const incoming = { ...(project.settings || {}) };
  if ('textAnimationDuration' in incoming) {
    if (!('coverTextAnimationDuration' in incoming)) incoming.coverTextAnimationDuration = incoming.textAnimationDuration;
    if (!('bodyTextAnimationDuration' in incoming)) incoming.bodyTextAnimationDuration = incoming.textAnimationDuration;
  }
  const settings = importProfileSettings(incoming);
  const images = rawImages.map(item => normalizeMediaItem(item, settings));
  const trialImages = (Array.isArray(project.trialImages) ? project.trialImages : []).map(item => normalizeMediaItem(item, settings));
  return {
    ...project,
    images,
    trialImages,
    script,
    settings,
    mode: images.length && !script.length ? 'media_only' : images.length === 1 && script.length === 1 ? 'cover_only' : 'standard'
  };
}

export function formatDuration(seconds) {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}

export function resolveExportSelection({ mainCount = 0, trialCount = 0, scope = 'auto', activeTab = 'main' } = {}) {
  const exportTrialsOnly = scope === 'trials' || (scope === 'auto' && activeTab === 'trials');
  const includeMain = (scope === 'main' || scope === 'all' || (scope === 'auto' && activeTab !== 'trials')) && mainCount > 0 && !exportTrialsOnly;
  const includeTrials = (scope === 'trials' || scope === 'all' || (scope === 'auto' && (activeTab === 'trials' || trialCount > 0))) && trialCount > 0;
  return { exportTrialsOnly, includeMain, includeTrials, jobCount: (includeMain ? 1 : 0) + (includeTrials ? trialCount : 0) };
}
